import linq from "linq";
import axios from 'axios'

//字符串扩展
{
    String.prototype.insert = function (i, insertstr) {
        if (i < 0) i = 0;
        if (i > this.length) i = this.length;
        let left = this.substring(0, i);
        let right = this.substring(i, this.length);
        return left + insertstr + right;
    }

    String.prototype.toFixed = function (x) {
        let str = this;
        return parseFloat(str).toFixed(x);
    }

    String.prototype.toDate = function () {
        let val = this;
        if (new RegExp(/^([1-9]\d{3})(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/).test(val.toString())) {
            let tmp = new RegExp(/^([1-9]\d{3})(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/).exec(val.toString());
            return new Date(tmp[1], parseInt(tmp[2]) - 1, tmp[3]);
        }
        else {
            return new Date(val);
        }
    }
}
//日期扩展
{
    Date.prototype.add = function (milliseconds) {
        var m = this.getTime() + milliseconds;
        return new Date(m);
    };
    Date.prototype.addSeconds = function (second) {
        return this.add(second * 1000);
    };
    Date.prototype.addMinutes = function (minute) {
        return this.addSeconds(minute * 60);
    };
    Date.prototype.addHours = function (hour) {
        return this.addMinutes(60 * hour);
    };
    Date.prototype.addDays = function (day) {
        return this.addHours(day * 24);
    };
    Date.isLeepYear = function (year) {
        return (year % 4 == 0 && year % 100 != 0);
    };
    Date.daysInMonth = function (year, month) {
        if (month == 2) {
            if (year % 4 == 0 && year % 100 != 0)
                return 29;
            else
                return 28;
        }
        else if ((month <= 7 && month % 2 == 1) || (month > 7 && month % 2 == 0))
            return 31;
        else
            return 30;
    };
    Date.prototype.addMonth = function () {
        var m = this.getMonth();
        if (m == 11) return new Date(this.getFullYear() + 1, 0, this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds());

        var daysInNextMonth = Date.daysInMonth(this.getFullYear(), this.getMonth() + 1);
        var day = this.getDate();
        if (day > daysInNextMonth) {
            day = daysInNextMonth;
        }
        return new Date(this.getFullYear(), this.getMonth() + 1, day, this.getHours(), this.getMinutes(), this.getSeconds());
    };
    Date.prototype.subMonth = function () {
        var m = this.getMonth();
        if (m == 0) return new Date(this.getFullYear() - 1, 11, this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds());
        var day = this.getDate();
        var daysInPreviousMonth = Date.daysInMonth(this.getFullYear(), this.getMonth());
        if (day > daysInPreviousMonth) {
            day = daysInPreviousMonth;
        }
        return new Date(this.getFullYear(), this.getMonth() - 1, day, this.getHours(), this.getMinutes(), this.getSeconds());
    };
    Date.prototype.addMonths = function (addMonth = 1) {
        var result = this;
        if (addMonth > 0) {
            while (addMonth > 0) {
                result = result.addMonth();
                addMonth--;
            }
        } else if (addMonth < 0) {
            while (addMonth < 0) {
                result = result.subMonth();
                addMonth++;
            }
        }
        return result;
    };
    Date.prototype.addYears = function (year = 1) {
        return new Date(this.getFullYear() + year, this.getMonth(), this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds());
    };
    Date.prototype.format = function (format) {
        format = format || 'yyyy-MM-dd hh:mm:ss'
        var o = {
            'M+': this.getMonth() + 1, //month
            'd+': this.getDate(),    //day
            'h+': this.getHours(),   //hour
            'm+': this.getMinutes(), //minute
            's+': this.getSeconds(), //second
            'q+': Math.floor((this.getMonth() + 3) / 3),  //quarter
            'S': this.getMilliseconds() //millisecond
        };
        if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
            (this.getFullYear() + '').substr(4 - RegExp.$1.length));
        for (var k in o) if (new RegExp('(' + k + ')').test(format))
            format = format.replace(RegExp.$1,
                RegExp.$1.length == 1 ? o[k] :
                    ('00' + o[k]).substr(('' + o[k]).length));
        return format;
    };
    Date.prototype.firstdate = function () {
        var year = this.getFullYear();
        var month = this.getMonth() + 1;
        return (new Date(year + '/' + month + '/01'));
    };
    Date.prototype.lastdate = function () {
        return this.firstdate().addMonth().addDays(-1);
    };
    Date.prototype.yearfirstdate = function () {
        var year = this.getFullYear();
        var month = 1;
        return (new Date(year + '/' + month + '/01'));
    };
    Date.prototype.yearlastdate = function () {
        return this.yearfirstdate().addYears(1).addDays(-1);
    };
    Date.prototype.dayStart = function (hour = 0) {
        let that = this;
        if (that.getHours() < hour) that = that.addDays(-1);
        return new Date(that.format('yyyy-MM-dd') + ' ' + hour + ':00:00');
    }
    Date.prototype.dayEnd = function (hour = 0) {
        let that = this;
        if (that.getHours() < hour) that = that.addDays(-1);
        return new Date(that.format('yyyy-MM-dd') + ' ' + hour + ':00:00').addDays(1).addSeconds(-1);
    }
    Date.prototype.monthDayStart = function (day = 1, hour = 0) {
        let that = this;
        if (that.getHours() < hour) that = that.addDays(-1);
        if (that.getDate() < day) that = that.addMonths(-1);
        return new Date(that.format('yyyy-MM-') + day + ' ' + hour + ':00:00');
    }
    Date.prototype.monthDayEnd = function (day = 1, hour = 0) {
        let that = this;
        if (that.getHours() < hour) that = that.addDays(-1);
        if (that.getDate() < day) that = that.addMonth(-1);
        return new Date(that.format('yyyy-MM-') + day + ' ' + hour + ':00:00').addMonth(1).addSeconds(-1);
    }
    Date.prototype.monthStart = function (day = 1) {
        let that = this;
        if (that.getDate() < day) that = that.addMonths(-1);
        return new Date(that.format('yyyy-MM-') + day);
    }
    Date.prototype.monthEnd = function (day = 1) {
        let that = this;
        if (that.getDate() < day) that = that.addMonths(-1);
        return new Date(that.format('yyyy-MM-') + day).addMonths(1).addDays(-1);
    }
    Date.prototype.yearDayStart = function (hour = 0) {
        let that = this;
        if (that.getMonth() == 0 && that.getHours() < hour) that = that.addDays(-1);
        var year = that.getFullYear();
        var month = 1;
        return (new Date(year + '/' + month + '/01' + ' ' + hour + ':00:00'));
    };
    Date.prototype.yearDayEnd = function (hour = 0) {
        return this.yearDayStart(hour).addYears(1).addSeconds(-1);
    };
}
//数组扩展
{
    Array.prototype.RemoveAll = function (str) {
        let index = this.findIndex($ => eval(str));
        while (index > -1) {
            this.splice(index, 1);
            index = this.findIndex($ => eval(str));
        }
    };
    Array.prototype.Sum = function (e) { return linq.from(this).sum(e); };
    Array.prototype.Where = function (e) { return linq.from(this).where(e).toArray(); };
    Array.prototype.Count = function (e) { return linq.from(this).count(e); };
    Array.prototype.Any = function (e) { return linq.from(this).any(e); };
    Array.prototype.Remove = function (obj) {
        this.splice(this.indexOf(obj), 1);
    };
    Array.prototype.FirstOrDefault = function (e) { return linq.from(this).firstOrDefault(e, undefined); };
    Array.prototype.Select = function (e) { return linq.from(this).select(e).toArray(); };
    Array.prototype.InArray = function (e) {
        if (!e) return false;
        for (let index = 0; index < this.length; index++) {
            const a = this[index];
            if (e.indexOf(a) < 0) return false;
        }
        return true;
    }
}
//数字扩展
{
    Math.Round = function (n, b) {
        let tmp = eval('1e' + (b || 0));
        return Math.round((n || 0) * tmp) / tmp;
    }
    Number.prototype.toPadding = function (length) {
        let num = this;
        for (var len = (num + "").length; len < length; len = num.length) {
            num = "0" + num;
        }
        return num.toString();
    }

    window.isNumber = function (a) {
        return typeof a === "number" && !Number.isNaN(a);
    }
}

JSON.tryParse = function (str) {
    let jo = null;
    try {
        jo = JSON.parse(str);
    } catch (error) {
        //
    }
    return jo
}

window.delay = function (time) {
    time = time || 1000;
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve('延时' + time + 'ms');
        }, time);
    });
};

window.location.query = function (name) {
    var str = location.search;
    str = str.replace(new RegExp("&amp;", "g"), "&");
    var result = str.match(new RegExp("[?&]" + name + "=([^&]+)", "i"));
    if (result == null || result.length < 1) {
        return "";
    }
    return result[1];
};

window.location.hashquery = function (name) {
    var str = location.hash;
    str = str.replace(new RegExp("&amp;", "g"), "&");
    var result = str.match(new RegExp("[?&]" + name + "=([^&]+)", "i"));
    if (result == null || result.length < 1) {
        return "";
    }
    return result[1];
};

//cookie
window.cookie = {
    addcookie: function (name, value, expireDay) {
        var cookieString = name + "=" + escape(value);
        if (expireDay > 0) {
            var date = new Date();
            date.setDate(date.getDate() + expireDay);
            cookieString = cookieString + "; expires=" + date.toGMTString();
        }
        document.cookie = cookieString;
    },
    getcookie: function (name) {
        var strcookie = document.cookie;
        var arrcookie = strcookie.split("; ");
        for (var i = 0; i < arrcookie.length; i++) {
            var arr = arrcookie[i].split("=");
            if (arr[0] == name) return unescape(arr[1]);
        }
        return "";
    },
    delcookie: function (name) {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = this.getcookie(name);
        if (cval != null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    },
}

export default {
    install(Vue) {
        Vue.filter('date', function (val, str) {
            try {
                str = str || 'yyyy-MM-dd hh:mm:ss';
                if (!val) return '';
                if (new Date(val) - new Date('1970-01-01 00:00:00') == 0) return '';

                //20200301  把这个格式转为实际
                if (new RegExp(/^([1-9]\d{3})(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/).test(val.toString())) {
                    let tmp = new RegExp(/^([1-9]\d{3})(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/).exec(val.toString());
                    return new Date(tmp[1], parseInt(tmp[2]) - 1, tmp[3]).format(str);
                }
                else {
                    if (typeof val == 'string' && val.indexOf('T') > -1) {
                        val = val.replace(/-/g, '/').replace(/T/g, ' ').split('.')[0];
                    }
                    return new Date(val).format(str);
                }
            } catch (error) {
                return '';
            }
        });
        Vue.filter('number', function (val, s) {
            try {
                if (typeof val == "string") val = parseFloat(val);
                val = val || 0;
                if (typeof s == "undefined") s = 2;
                return val.toFixed(s)
            } catch (error) {
                return '';
            }
        });
        Vue.filter('phone', function (val, s) {
            try {
                return val.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
            } catch (error) {
                return val;
            }
        });
        Vue.prototype.$Alert = async function (title, error, icon) {
            if (!title && !error) return;
            if (title == 'cancel' && !error) return;
            if (!error) { error = title; title = "提示"; }

            if (typeof error === "string") {
                if (this.$dialog) {
                    await this.$dialog.alert({
                        title: title,
                        message: error
                    });
                } else if (this.$alert) {
                    await this.$alert(error,
                        title, {
                        dangerouslyUseHTMLString: true
                    });
                } else alert(error);
            } else {
                let msg = error.message || error.error || '';
                let stack = error.stack || '';
                if (this.$dialog) {
                    await this.$dialog.alert({
                        title: title,
                        message: msg + `<p style="text-align: right;color: blue;padding-right: 15px;` +
                            (stack ? '' : 'display: none;')
                            + `" href="#" onclick="if(document.getElementById('xx').style.display=='none') document.getElementById('xx').style.display='block'; else document.getElementById('xx').style.display='none';">详细</p>
        <p id="xx" style="display: none;max-height: 300px;overflow-y: auto;">` +
                            stack
                            + '</p>',
                    });
                } else if (this.$alert) {
                    await this.$alert(msg +
                        `<p style="text-align: right;color: blue;padding-right: 15px;` +
                        (stack ? '' : 'display: none;')
                        + `" href="#" onclick="if(document.getElementById('xx').style.display=='none') document.getElementById('xx').style.display='block'; else document.getElementById('xx').style.display='none';">详细</p>
        <p id="xx" style="display: none;max-height: 300px;overflow-y: auto;">` +
                        stack
                        + '</p>',
                        title, {
                        dangerouslyUseHTMLString: true,
                        type: icon || 'info',
                    });
                } else alert(msg || error);
            }
        };
        Vue.prototype.$postAsync = async function (url, postdata, showloading = true, timeouttime = 1000 * 10) {
            let data;
            let loading;
            try {
                if (showloading) {
                    if (this.$toast)
                        loading = this.$toast.loading({
                            mask: true,
                            duration: 0,
                            message: '正在获取数据,请稍后...'
                        });
                    else if (this.$loading) {
                        loading = this.$loading({
                            lock: true,
                            text: '正在获取数据,请稍后...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                    }
                }

                let result = await axios({
                    method: "POST",
                    url: url,
                    data: postdata,
                    timeout: timeouttime,
                });
                // eslint-disable-next-line no-console
                console.log('' + url + '======================\r\n', postdata, result.data);
                data = result.data;
                if (!data.result) throw new Error('返回数据格式错误,缺少result!');
            } catch (error) {
                if (loading) {
                    if (this.$toast) loading.clear();
                    if (this.$loading) loading.close();
                }
                if (error.response) {    //服务器有返回
                    let msg = error.response.status;
                    if (error.response.status == '429') msg += '访问太频繁了';
                    if (error.response.status == '404') msg += '网页不存在';
                    throw '服务器' + msg + '错误(' + error.response.statusText + ')';
                } else if (error.request) {  //没有返回,只有请求
                    if (error.message == "Network Error") throw { message: '网络错误，连接互联网失败,请检查是否能够上网!', stack: error.stack };
                    if (error.message.indexOf('timeout of') > -1) throw { message: '连接超时,网速过慢,请重试!', stack: error.stack };
                }
                throw error;
            }
            if (loading) {
                if (this.$toast) loading.clear();
                if (this.$loading) loading.close();
            }

            if (data.result != '成功') {
                if (this.$router && data.error && (data.error.includes('重新登录') || data.error.includes('请登录'))) {
                    this.$router.push("/login");
                    throw '';
                }
                else throw { message: data.error, stack: data.stack };
            }
            return data;
        };
        Vue.prototype.$wait = function (flag, time = 1000, errmsg = null) {
            let start = new Date(), _this = this;
            return new Promise((resolve, rejected) => {
                let check = async function (flag, time, errmsg) {
                    let checkresult = false;
                    try {
                        if (typeof flag == 'function') await flag(_this)
                        else checkresult = eval("_this." + flag);
                        //flag不能直接传值,因为值改变后,函数里不会改变 
                    } catch (error) {
                        console.log(error);
                    }
                    if (checkresult) {
                        resolve("成功")
                    } else {
                        if ((new Date() - start) < time) setTimeout(() => { check(flag, time, errmsg); }, 100);
                        else rejected(errmsg || ("等待结果超时(" + time + ")"));
                    }
                }
                check(flag, time, errmsg);
            })
        };
        Vue.prototype.$waitfun = function (fun, time = 1000, errmsg) {
            let start = new Date, _this = this;
            return new Promise((resolve, rejected) => {
                let check = async function () {
                    let checkresult = false;
                    try {
                        checkresult = await fun(_this)
                    } catch (error) {
                        //
                    }
                    if (checkresult) {
                        resolve(checkresult)
                    } else {
                        if (new Date - start < time) setTimeout(check, 10)
                        else rejected(errmsg || ("等待结果超时(" + time + ")"))
                    }
                }
                check();
            })
        };
        // Vue.myGlobalMethod = function () {  // 1. 添加全局方法或属性，如:  vue-custom-element
        //     // 逻辑...
        // }
        // Vue.directive('my-directive', {  // 2. 添加全局资源：指令/过滤器/过渡等，如 vue-touch
        //     bind(el, binding, vnode, oldVnode) {
        //         // 逻辑...
        //     }
        // })
        // Vue.mixin({
        //     created: function () {  // 3. 通过全局 mixin方法添加一些组件选项，如: vuex
        //         // 逻辑...
        //     }
        // })
    }
}